import { Grid, Stack, Typography } from '@mui/material'
import { ControlledInput } from '../../../components/forms/input/ControlledInput'
import { ControlledTextArea } from '../../../components/forms/input/ControlledTextArea'
import { useForm } from 'react-hook-form'
import { SaveModel } from '../../../components/modal/SaveModal'
import { CancelModel } from '../../../components/modal/CancelModal'
import { useEffect } from 'react'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const CustomerLockerReleaseForm = ({ selectedItem, setSelectedItem, setOpen, setMainValue }: { selectedItem: any, setSelectedItem: (value: any) => void, setOpen: (value: boolean) => void, setMainValue: any }) => {
    const cancelMessage = 'Cancel current unsaved changes and go back to customer detail?'
    const { handleSubmit, control, setValue, watch, formState: { errors, } } = useForm<valuesTypes>(
        {
            resolver: yupResolver(LockerReleaseSchema),
            defaultValues: { lockerReleaseCharge: '', remarks: '' }
        })

    const onSubmit = () => {
        setMainValue(`customerLockers.${selectedItem.itemIndex}.remarks`, `Release Charge: ${watch('lockerReleaseCharge')} - ${watch('remarks') ?? ''}`)
        setMainValue(`customerLockers.${selectedItem.itemIndex}.lockerReleaseCharge`, watch('lockerReleaseCharge'))
        setMainValue(`customerLockers.${selectedItem.itemIndex}.lockerstatus`, 0)
        setOpen(false);
        setSelectedItem(null)
    };

    const handleClose = () => {
        setValue('lockerReleaseCharge', '')
        setValue('remarks', '')
        setOpen(false);
        setSelectedItem(null)
    };

    useEffect(() => {
        if (selectedItem) {
            setValue('lockerReleaseCharge', selectedItem?.lockerReleaseCharge)
            setValue('remarks', selectedItem?.remarks)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            <Typography component={'p'} mt={2} mb={2}>Release Information</Typography>
            <Grid container spacing={2}>
                <Grid item xs={6} >
                    <ControlledInput type="number" name={`lockerReleaseCharge`} control={control} errors={errors} label="Release Charge" />
                </Grid>
                <Grid item xs={12} >
                    <ControlledTextArea name={`remarks`} control={control} errors={errors} label="Remarks" />
                </Grid>

            </Grid>
            <Stack direction='row' justifyContent='flex-end' spacing={3} mt={5}>
                <CancelModel handleModalClose={handleClose} message={cancelMessage} />
                <SaveModel onSubmit={handleSubmit(onSubmit)} selectedItem={selectedItem} />
            </Stack>
        </>
    )
}

export default CustomerLockerReleaseForm

export type valuesTypes = {
    lockerReleaseCharge: string,
    remarks: string
}

const LockerReleaseSchema = yup.object().shape({
    lockerReleaseCharge: yup.number().required('Release Charge is required').typeError('Release Charge is required'),
    remarks: yup.string().nullable()
})